import script from "./PartnersSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PartnersSection.vue?vue&type=script&setup=true&lang=ts"

import "./PartnersSection.vue?vue&type=style&index=0&id=0327df66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0327df66"]])

export default __exports__